// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__N3qpq","inputLabel":"Input_inputLabel__kxhpr","inputElement":"Input_inputElement__HtbMO"};